import React, { FunctionComponent } from 'react';
import { StyledArrowRightLong, StyledCurrencyFormat, Wrapper } from './PackageOldPrice.style';

type Props = {
  value?: number;
};

export const PackageOldPrice: FunctionComponent<Props> = ({ value }) => {
  if (!value) {
    return null;
  }
  return (
    <Wrapper>
      <StyledArrowRightLong />
      <StyledCurrencyFormat value={value} />
    </Wrapper>
  );
};
